
<svelte:options accessors={true} />

<script>

  import { writable } from 'svelte/store';

  import action from '~/action';
  import { searchTerm, viewActive } from 'apps/imd/stores';
  import UseResource from 'components/svg/UseResource.svelte';

  export const input = writable();

  let _input;

  $: if (_input) {
    input.set(_input);
  }

  function clear () {
    searchTerm.set('');
    clickSearchBar();
  }

  function clickSearchBtn () {
    switch ($viewActive) {
    case 'search': return action.goTo('searchresults');
    case 'searchresults': return action.goTo('search');
    default:
      console.error(`Not implemented for '${$viewActive}'`);
    }
  }

  function keydown (event) {
    if (event.key == 'Enter' && $viewActive == 'search') action.goTo('searchresults');
  }

  function clickSearchBar () {
    switch ($viewActive) {
    case 'search': return;
    case 'searchresults': return action.goTo('search');
    default:
      console.error(`Not implemented for '${$viewActive}'`);
    }
  }
</script>

<div class="search-bar">
  <input type="text" bind:value={$searchTerm}
    bind:this={_input} on:click="{() => clickSearchBar()}" on:keydown={keydown}
    data-testid="search-bar__input">
  {#if $searchTerm}
    <button class="clear" type="button" on:click="{() => clear()}" title="Clear search">
      <span>&times;</span>
    </button>
  {/if}
  <button class="search" type="button" on:click="{() => clickSearchBtn()}" title="Make search">
    <UseResource name="ic_search" size="48px" />
  </button>
</div>


<style>
  .search-bar {
    display: flex;
    flex-grow: 1;
    margin-left: 15px;
    margin-right: 96px;
    background: var(--search-bar--bg);
    border: var(--search-bar--border);
    border-radius: var(--search-bar--borderRadius);
    overflow: hidden;
  }

  .search-bar *:focus {
    outline: none;
  }

  input {
    flex-grow: 1;
    padding: 0 16px;
    background: transparent;
    border: none;
    color: var(--search-bar--color);
    font-size: 32px;
  }

  .clear {
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    background: transparent;
    border: none;
    color: var(--search-bar--color);
    font-size: 48px;
  }

  .clear span {
    /* &times; tend to be close baseline -> consider SVG instead */
    position: relative;
    top: -4px;
  }

  .search {
    width: 96px;
    height: 72px;
    flex-shrink: 0;
    background: var(--highlight);
    border: none
  }

  .search :global(.resource) {
    filter: var(--icon-on-highlight--filter, none);
  }
</style>
